import { render, staticRenderFns } from "./HeadDiagram.vue?vue&type=template&id=da8971fe&scoped=true"
import script from "./HeadDiagram.vue?vue&type=script&lang=js"
export * from "./HeadDiagram.vue?vue&type=script&lang=js"
import style0 from "./HeadDiagram.vue?vue&type=style&index=0&id=da8971fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8971fe",
  null
  
)

export default component.exports